import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=167ace5c&scoped=true&"
import script from "./Registration.vue?vue&type=script&lang=js&"
export * from "./Registration.vue?vue&type=script&lang=js&"
import style0 from "@/tbs/stylesheet/dynamic.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Registration.vue?vue&type=style&index=1&id=167ace5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ace5c",
  null
  
)

export default component.exports